import React from 'react';
import './shimmer.css';
import { useTheme } from '../../../styles/ThemeProvider';

export const SkeletonTable = ({ rows = 5 }) => {
  const { theme } = useTheme();
  return (
    <div style={{ background: theme.color.surface, border: `1px solid ${theme.color.border}`, borderRadius: theme.radius.md, padding: theme.space.lg }}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="analytics-skeleton" style={{ height: 14, marginBottom: theme.space.md, width: `${70 + (i % 3) * 10}%` }} />
      ))}
    </div>
  );
};
